import { FormSubmissionDetailApiResponse } from '@features/forms/types/formSubmissionDetailApi';

const MOCK_SUBMISSION_DETAILS: Record<string, FormSubmissionDetailApiResponse> =
  {
    drop_1: {
      id: 'drop_1',
      name: 'Rahul Verma',
      mobile: '+919900112233',
      add_to_mode: 'group',
      group: { id: 'grp_dance', name: 'Dance Class A' },
      source: 'WhatsApp',
      version: 2,
      form_name: 'Annual fee collection',
      branch_name: 'TimeKids Palarivattom',
      organisation_name: 'TimeKids.Ltd',
      member_id: 'mem_drop_1',
      payment_details: {
        fee_amount: 12000,
        total_amount: 12000,
        paid_amount: 0,
        is_partial_payment_enabled: false,
        payment_order_id: 'ord_drop_1'
      },
      form_submission: [
        {
          field_name: 'Registration name',
          field_type: 'basic',
          field_value: ['Rahul Verma'],
          is_required: true
        },
        {
          field_name: 'Mobile number',
          field_type: 'basic',
          field_value: ['+919900112233'],
          is_required: true
        },
        {
          field_name: 'Email ID',
          field_type: 'member',
          field_value: ['rahul.verma@example.com']
        }
      ]
    },
    drop_2: {
      id: 'drop_2',
      name: 'Priya Sharma',
      mobile: '+919876543210',
      add_to_mode: 'group',
      group: { id: 'grp_yoga', name: 'Yoga class A' },
      source: 'Instagram',
      version: 2,
      form_name: 'Annual fee collection',
      branch_name: 'TimeKids Palarivattom',
      organisation_name: 'TimeKids.Ltd',
      member_id: 'mem_drop_2',
      payment_details: {
        fee_amount: 6000,
        total_amount: 6000,
        paid_amount: 0,
        is_partial_payment_enabled: false,
        payment_order_id: 'ord_drop_2'
      },
      form_submission: [
        {
          field_name: 'Registration name',
          field_type: 'basic',
          field_value: ['Priya Sharma'],
          is_required: true
        },
        {
          field_name: 'Mobile number',
          field_type: 'basic',
          field_value: ['+919876543210'],
          is_required: true
        }
      ]
    },
    sub_1: {
      id: 'sub_1',
      name: 'Anjali Nair',
      mobile: '+919383437343',
      add_to_mode: 'group',
      group: { id: 'grp_dance', name: 'Dance Class A' },
      source: 'Whatsapp',
      version: 2,
      form_name: 'Annual fee collection',
      branch_name: 'TimeKids Palarivattom',
      organisation_name: 'TimeKids.Ltd',
      member_id: 'mem_sub_1',
      payment_details: {
        fee_amount: 2000,
        total_amount: 1800,
        paid_amount: 1000,
        total_discount_amount: 1000,
        is_partial_payment_enabled: false,
        payment_order_id: 'ord_lySCuf5Hyd6785',
        paid_at: '2025-03-26T11:00:00Z',
        settled_at: '2025-03-26T12:00:26Z',
        settlement_utr: '617315195832',
        note: 'Scholarship fee',
        payment_mode: 'online',
        payment_method: 'CoFee'
      },
      form_submission: [
        {
          field_name: 'Registration name',
          field_type: 'basic',
          field_value: ['Anjali Nair'],
          is_required: true
        },
        {
          field_name: 'Mobile number',
          field_type: 'basic',
          field_value: ['+919383437343'],
          is_required: true
        },
        {
          field_name: 'Roll number',
          field_type: 'custom',
          field_value: ['04']
        },
        {
          field_name: 'Parent/Guardian name',
          field_type: 'member',
          field_value: ['Sarath Nair']
        },
        {
          field_name: 'Parent/Guardian contact',
          field_type: 'member',
          field_value: ['+919383437343']
        },
        {
          field_name: 'Email ID',
          field_type: 'member',
          field_value: ['sarathnair89@gmail.com']
        },
        {
          field_name: 'What are you most interested in at this event?',
          field_type: 'custom',
          field_value: ['Keynote Sessions', 'Entertainment Activities']
        },
        {
          field_name: 'Preferred Mode of Communication',
          field_type: 'custom',
          field_value: ['Whatsapp']
        },
        {
          field_name: 'How did you hear about this event?',
          field_type: 'custom',
          field_value: ['Social Media']
        }
      ]
    }
  };

export const getMockSubmissionDetailApi = (
  submissionId: string
): FormSubmissionDetailApiResponse | undefined =>
  MOCK_SUBMISSION_DETAILS[submissionId];

export default getMockSubmissionDetailApi;
